"use strict";

exports.__esModule = true;
exports.LegacyContext = void 0;
var _LegacyController = require("./LegacyController");
var _Utils = require("../../../Utils");
/**
 * Provides a legacy context to consumers
 * @component
 */
var LegacyContext = exports.LegacyContext = (0, _Utils.createEnhancedContext)({
  propName: "legacy",
  defaultController: _LegacyController.LegacyController
});